/**
 * Grab a still frame from the back-camera video as a compressed JPEG data URL,
 * downscaled to a maximum edge. Used only by the consented Watcher (VLM) path —
 * this is the frame that leaves the device.
 */

import { VLM } from '../config.js';

export function captureFrame(video: HTMLVideoElement): string | null {
  const vw = video.videoWidth;
  const vh = video.videoHeight;
  if (!vw || !vh || video.readyState < 2) return null;

  const scale = Math.min(1, VLM.maxEdge / Math.max(vw, vh));
  const w = Math.round(vw * scale);
  const h = Math.round(vh * scale);

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  ctx.drawImage(video, 0, 0, w, h);
  try {
    return canvas.toDataURL('image/jpeg', VLM.quality);
  } catch {
    return null;
  }
}
